histories-schedule-updated
  span.event {this.locale().event}
  span.updated
    histories-updated.start_time(if="{opts.json.start_time != undefined}" tag-scope="{this.tagScope}" scope="start_time" locale="{locale()}" getter="{dateFormat}" label-style="background: {phaseColorCode()}")
    histories-updated.end_time(if="{opts.json.end_time != undefined}" tag-scope="{this.tagScope}" scope="end_time" locale="{locale()}" getter="{dateFormat}" label-style="background: {phaseColorCode()}")
  script(type="typescript").
    this.mixin('histories.base');
